import PrescriptionMakingPage from './index'
import PrescriptionDataProvider from './context/PrescriptionDataProvider'
import ScreeningSectionsProvider from './context/ScreeningSectionsProvider'

const PrescriptionMakingPageWithContext = () => {
  return (
    <PrescriptionDataProvider>
      <ScreeningSectionsProvider>
        <PrescriptionMakingPage />
      </ScreeningSectionsProvider>
    </PrescriptionDataProvider>
  )
}

PrescriptionMakingPageWithContext.displayName = 'PrescriptionMakingPageWithContext'

export default PrescriptionMakingPageWithContext
